import { render, staticRenderFns } from "./AccountNavigationDrawer.vue?vue&type=template&id=2554206d&scoped=true&"
import script from "./AccountNavigationDrawer.vue?vue&type=script&lang=js&"
export * from "./AccountNavigationDrawer.vue?vue&type=script&lang=js&"
import style0 from "./AccountNavigationDrawer.vue?vue&type=style&index=0&id=2554206d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2554206d",
  null
  
)

export default component.exports